import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProgressiveAssetController } from './ProgressiveAssetController';
import { ProgressiveAssetSkeleton } from './ProgressiveAssetSkeleton';
import { Container } from './styles';
export const ProgressiveAssetWrapperSkeleton = () => {
    const { hasLoaded } = ProgressiveAssetController.useContainer();
    return _jsx(ProgressiveAssetSkeleton, { isVisible: !hasLoaded, isBlock: true });
};
export const ProgressiveAssetWrapper = ({ aspectRatios, children }) => {
    return (_jsx(ProgressiveAssetController.Provider, { children: _jsxs(Container, { "$aspectRatios": aspectRatios, children: [_jsx(ProgressiveAssetWrapperSkeleton, {}), children] }) }));
};
//# sourceMappingURL=ProgressiveAssetWrapper.js.map